import baseStyled, { css as baseCss, ThemedCssFunction, ThemedStyledInterface } from 'styled-components';
import { HomeScreenTheme } from './themes/types'; // Ensure this points to your theme types

const styled = baseStyled as ThemedStyledInterface<HomeScreenTheme>;
const css = baseCss as ThemedCssFunction<HomeScreenTheme>;

export const HomeScreenContainer = styled.div`
  //background-color: ${(props) => props.theme.mode.homeScreen.backgroundColor};
  //background: ${(props) => props.theme.mode.homeScreen.backgroundGradient};
  color: ${(props) => props.theme.mode.homeScreen.textColor};
  &:hover {
    //background-color: ${(props) => props.theme.mode.homeScreen.hoverBackgroundColor};
  }
  height: 100%;
`;
